import React from 'react'

 const OkIcon = () => {
  return (
<svg id="_05-全局提示_反馈图标" data-name="05-全局提示/反馈图标" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <rect id="占位" width="20" height="20" fill="#fff" opacity="0"/>
  <g id="check-circle-filled">
    <rect id="check-circle-filled_Background_" data-name="check-circle-filled (Background)" width="20" height="20" fill="none"/>
    <path id="check-circle-filled-2" data-name="check-circle-filled" d="M8.75,17.5A8.75,8.75,0,1,1,17.5,8.75,8.76,8.76,0,0,1,8.75,17.5ZM5.258,8.125h0l-.883.883L7.5,12.134,13.125,6.51l-.884-.885L7.5,10.366,5.258,8.125Z" transform="translate(1.25 1.25)" fill="#00a870"/>
  </g>
</svg>



  );
};
export default OkIcon
